var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Voucher/VoucherListView.js",
    _this = this;

import React, { useMemo } from 'react';
import { Container, CouponCover, CouponBody, TagWrapper, Title, SubTitle, ValueWrapper, Value, CutOut } from './VoucherListView.style';
var TITLE_MAX_LINES = {
  TITLE_ONLY: 3,
  OTHER: 2
};

var VoucherListView = function VoucherListView(_ref) {
  var tag = _ref.tag,
      cover = _ref.cover,
      title = _ref.title,
      status = _ref.status,
      statusText = _ref.statusText,
      value = _ref.value,
      valueIcon = _ref.valueIcon,
      disabled = _ref.disabled,
      curveStyle = _ref.curveStyle;
  var titleMaxLines = useMemo(function () {
    return statusText !== undefined || value !== undefined ? TITLE_MAX_LINES.OTHER : TITLE_MAX_LINES.TITLE_ONLY;
  }, [statusText, value]);
  return /*#__PURE__*/React.createElement(Container, {
    curveStyle: curveStyle,
    disabled: disabled,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(CouponCover, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }, cover, tag && /*#__PURE__*/React.createElement(TagWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 17
    }
  }, tag)), /*#__PURE__*/React.createElement(CouponBody, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: 0
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Title, {
    maxLines: titleMaxLines,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 11
    }
  }, title)), statusText && /*#__PURE__*/React.createElement(SubTitle, {
    expiring: status === 'expiring',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 11
    }
  }, statusText), value && /*#__PURE__*/React.createElement(ValueWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 11
    }
  }, valueIcon, /*#__PURE__*/React.createElement(Value, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 13
    }
  }, value))), /*#__PURE__*/React.createElement(CutOut, {
    backgroundColor: curveStyle === null || curveStyle === void 0 ? void 0 : curveStyle.backgroundColor,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 7
    }
  }));
};

export default VoucherListView;